import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toJS } from '../../../utils/immutableUtils';

import { getFetchError, getIsFetching, getPpsiById } from '../selectors';
import { fetchPpsi } from '../actions';

const usePpsi = (id, { forceFetch = false } = {}) => {
  const dispatch = useDispatch();

  const [isMounted, setIsMounted] = useState(false);
  const ppsi = useSelector(getPpsiById(id));
  const isFetchingPpsi = useSelector(getIsFetching);
  const fetchError = useSelector(getFetchError);
  const isFetching = !isMounted ? true : isFetchingPpsi;
  const isFetched = !!ppsi;

  useEffect(() => {
    if (isMounted) {
      return;
    }
    if (!isFetched || forceFetch) {
      dispatch(fetchPpsi(id));
    }
    setIsMounted(true);
  }, [id, dispatch, forceFetch, isFetched, isMounted]);

  return [isFetching, isFetching ? null : toJS(ppsi), fetchError];
};

export default usePpsi;
